const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, iframe:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';

/** Svelte action: contain keyboard focus and return it to the opening control. */
export function focusDialog(node, options) {
  const doc = node.ownerDocument;
  const previous = doc.activeElement;
  let settings = options;
  let focusCheck;
  const controls = () => Array.from(node.querySelectorAll(FOCUSABLE))
    .filter((element) => !element.matches(':disabled') && element.getClientRects().length > 0 && !element.hidden);
  queueMicrotask(() => {
    if (node.isConnected) (settings.initialFocus === 'dialog' ? node : controls()[0] || node).focus({ preventScroll: true });
  });

  function keydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      settings.onClose();
      return;
    }
    if (event.key !== 'Tab') return;
    const elements = controls();
    const index = elements.indexOf(doc.activeElement);
    const next = event.shiftKey ? (index <= 0 ? elements.length - 1 : index - 1)
      : (index + 1) % elements.length;
    clearTimeout(focusCheck);
    if (!elements.length) {
      event.preventDefault();
      node.focus();
    } else if (doc.activeElement === node || !node.contains(doc.activeElement)
      || event.shiftKey && index === 0 || !event.shiftKey && index === elements.length - 1) {
      event.preventDefault();
      elements[next].focus();
    } else {
      // Native navigation reaches controls inside opaque embedded widgets.
      // Safari can skip enabled buttons and leave the dialog; repair that escape.
      focusCheck = setTimeout(() => {
        if (node.isConnected && !node.contains(doc.activeElement)) elements[next].focus();
      }, 0);
    }
  }
  node.addEventListener('keydown', keydown);
  return {
    update(next) { settings = next; },
    destroy() {
      clearTimeout(focusCheck);
      node.removeEventListener('keydown', keydown);
      if (previous?.isConnected) previous.focus();
    }
  };
}
